import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Papa from 'papaparse';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { CSVLink } from 'react-csv';
import { useParams } from 'react-router-dom';
import { notification } from 'antd';
import { getToken } from '../../utils/TokenUtils';

const CSVUploader2 = () => {
  const [csvData, setCsvData] = useState(null);
  const [columnMapping, setColumnMapping] = useState({});
  const [errorRecords, setErrorRecords] = useState([]);
  const [successRecords, setSuccessRecords] = useState([]);
  const [link, setLink] = useState([]);
  const token = getToken();
  const { route } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const startTime = Date.now(); // Start time for the request

        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/${route}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        console.log('response.data.report:', response.data.report);
        setLink(response.data?.link);

        document.title = response.data.link?.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        notification.error({ message: error.message });
        setLink([]);
      }
    };

    fetchData();
  }, [route]);

  console.log('report link:', link);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      complete: (result) => {
        setCsvData(result.data);
      },
      header: true, // Parses first row as column names
      skipEmptyLines: true,
    });
  };

  const handleColumnMapping = (csvColumn, mysqlColumn) => {
    setColumnMapping((prev) => {
      // Create a new object without the existing mapping for this value
      const updatedMapping = Object.fromEntries(
        Object.entries(prev).filter(([key, value]) => value !== mysqlColumn)
      );

      // Add the new mapping
      updatedMapping[csvColumn] = mysqlColumn;

      console.log('Updated columnMapping:', updatedMapping);
      return updatedMapping;
    });
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('file', csvData);
    formData.append('table', link?.table_name);
    formData.append('mapping', JSON.stringify(columnMapping));

    const response = await axios.post(
      `${API_URL}/${ENDPOINTS.SYS}/csv-uploader`,
      formData
    );
    console.log('res:', response);
    alert('CSV Uploaded Successfully!');
  };

  // Send Data to API
  const handleUploadToServer = () => {
    // formData.append('file', csvData);
    // formData.append('table', selectedTable);
    // formData.append('mapping', JSON.stringify(columnMapping));

    axios
      .post(`${API_URL}/${ENDPOINTS.SYS}/upload-csv`, {
        data: csvData,
        table: link?.table_name,
        columns: link?.columns,
      })
      .then((res) => {
        setSuccessRecords(res.data.success);
        setErrorRecords(res.data.errors);
        console.log('res:', res.data);
      })
      .catch((err) => console.error('Upload Error:', err));
  };

  return (
    <div className="container">
      <h2>Upload CSV to MySQL</h2>

      <div className="d-flex align-items-start flex-wrap gap-3">
        <div className="d-flex flex-column mb-3">
          <label className="form-label text-capitalize font-weight-bold">
            Choose Csv File:
          </label>
          <input
            type="file"
            className="form-control"
            accept=".csv"
            onChange={handleFileChange}
          />
        </div>
        <div className="d-flex flex-column mb-3">
          <label
            htmlFor=""
            className="form-label text-capitalize font-weight-bold"
          >
            <span className="text-danger">&nbsp;</span>
          </label>
          <button className="btn btn-primary" onClick={handleUploadToServer}>
            Upload
          </button>
        </div>

        {link?.columns && (
          <div>
            <h1>Upload Notice</h1>
            <p className="text-danger">
              Please only upload .csv file, before upload check your csv columns
              same as like this table
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  {/* Loop through the array and create a <th> for each */}
                  {link?.columns?.split(',').map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* Loop through the array and create a <th> for each */}
                  {link?.columns?.split(',').map((header, index) => (
                    <td key={index}>--</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      {errorRecords && errorRecords.length > 0 && (
        <>
          <h2>
            ❌ Failed Uploads -{' '}
            <CSVLink
              data={errorRecords}
              filename={link?.table_name + '-error.csv'}
              className="btn btn-danger mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(errorRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                  <th>Error Message</th>
                </tr>
              </thead>
              <tbody>
                {errorRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                    <td>{row.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {successRecords && successRecords.length > 0 && (
        <>
          <h2>
            ✅ Successfully Uploads -{' '}
            <CSVLink
              data={successRecords}
              filename={link?.table_name + '-success.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(successRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {successRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {csvData && csvData.length > 0 && (
        <>
          <h2>CSV Preview</h2>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(csvData[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default CSVUploader2;
